<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    persistent
    scrollable
    :style="{ zIndex: options.zIndex }"
    content-class="align-self-start"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title primary-title>
        {{ title }}
      </v-card-title>
      <v-card-text
        v-show="!!message"
        v-html="message"
      />
      <v-divider />
      <v-card-actions>
        <v-btn
          v-show="options.cancelText !== ''"
          color="error"
          text
          @click.native="cancel"
        >
          {{ options.cancelText }}
        </v-btn>
        <v-spacer />
        <v-btn
          v-show="options.okText !== ''"
          text
          @click.native="ok"
        >
          {{ options.okText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Vuetify Alert Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="alert"></confirm>
 *
 * Call it:
 * this.$refs.alert.open('Delete', 'Are you sure?', { color: 'red' }).then(() => {})
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$alert
 * <template>
 *   <v-app>
 *     ...
 *     <alert ref="alert"></alert>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$alert = this.$refs.alert.open
 * }
 */
export default {
  name: 'AlertComponent',
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      color: 'primary',
      width: 400,
      zIndex: 200,
      okText: 'Ok',
      cancelText: 'Cancel'
    }
  }),
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.$store.commit('config/INCREMENT_DIALOGS_OPEN');
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    ok() {
      this.resolve(true);
      this.dialog = false;
      this.$store.commit('config/DECREMENT_DIALOGS_OPEN');
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
      this.$store.commit('config/DECREMENT_DIALOGS_OPEN');
    }
  }
};
</script>
